import axios from 'axios';
import {
  TRAIT_EMAIL,
  TRAIT_USER_ID,
  track,
} from 'rp-analytics';

export const brazeEmailSubscription = async (payload) => {
  const email = payload.email;
  const userId = payload.clientUserId;
  const options = payload.customParameters;

  function checkAllComunicationsIfFalse(option) {
    return Number(option) !== 1;
  }

  const allComunicationOptions = [
    options.RP_newsletterThirdParty,
    options.RP_horseBetting,
    options.RP_horseNews,
    options.RP_sportBetting,
    options.RP_bloodstock,
    options.RP_competitions,
    options.membersBriefing,
    options.theFrontRunner,
    options.theUltimateDaily,
    options.subscriberRewards,
  ];

  const traits = {
    [TRAIT_EMAIL]: email,
    [TRAIT_USER_ID]: userId,
  };

  const isAnyCommunicationSelected = allComunicationOptions.every(checkAllComunicationsIfFalse) ? 1 : 0;

  if (isAnyCommunicationSelected) {
    return {};
  }

  const preptEmailGroups = {
    RP_newsletterThirdParty: options.RP_newsletterThirdParty,
    RP_horseBetting: options.RP_horseBetting,
    RP_horseNews: options.RP_horseNews,
    RP_bloodstock: options.RP_bloodstock,
    RP_sportBetting: options.RP_sportBetting,
    RP_competitions: options.RP_competitions,
    membersBriefing: options.membersBriefing,
    theFrontRunner: options.theFrontRunner,
    theUltimateDaily: options.theUltimateDaily,
    subscriberRewards: options.subscriberRewards,
  };

  const userEmialGroups = Object.entries(preptEmailGroups);
  // eslint-disable-next-line
    const filterUserSubscribedGroups = userEmialGroups.filter(([name, value])=> value > 0 ).map(([name]) => name);
  const emailLabel = 'email';
  const getAccountInfoOptions = {
    url: '/subscriptions/braze',
    baseURL: `${window.location.protocol}//${window.location.host}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    data: {
      [emailLabel]: email,
      emailSubscriptions: filterUserSubscribedGroups,
    },
  };

  try {
    const { data } = await axios(getAccountInfoOptions);
    const SUBS_TRAIT = 'subscriptions';
    traits[SUBS_TRAIT] = data;

    track('SignUp Email Subscriptions', traits);

    return data;
  } catch (error) {
    const API_REQ_ERROR = 'Api request error';
    traits[API_REQ_ERROR] = error;

    track('SignUp Email Subscriptions error', traits);

    return error;
  }
};
